import {
  makeUrl,
  get,
} from '../../utils/fetcher';

import {METHODS} from '../../constants';

import {types} from './actionTypes';

export function getUserOrganizations() {
  const url = makeUrl(METHODS.GET_USER_ORGANIZATIONS);
  return (dispatch) => get(url, dispatch)
    .then((response) => {
      let accounts = [];
      if (response && response.data) {
        accounts = response.data;
        dispatch({
          type: types.SET_USER_ORGANIZATIONS,
          data: accounts,
        });
      }
      return accounts;
    });
}
